
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brands/[brand_slug]",
      function () {
        return require("private-next-pages/brands/[brand_slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brands/[brand_slug]"])
      });
    }
  